import { z } from "zod";
import { isValidGuestSignInId, normalizeGuestSignInId } from "../utils/guestSignInId.js";
export const SocialSignInProviderSchema = z.enum(["google", "facebook", "twitter", "github", "microsoft"]);
/**
 * The sign-in methods currently switched on in the project's Firebase
 * Authentication settings. Turning a method on or off in the Firebase
 * Console shows or hides it on the sign-in pages; there is no separate flag.
 */
export const SignInMethodsSchema = z.object({
    emailPassword: z.boolean(),
    emailLink: z.boolean(),
    guest: z.boolean(),
    // A newer server may name a provider an older bundle doesn't know; drop it, keep the rest.
    social: z.array(z.string()).transform((ids) => ids.filter((id) => SocialSignInProviderSchema.safeParse(id).success)),
});
/** Body of the public `/signInWithGuestId` endpoint (issue #332). */
export const GuestSignInIdSchema = z.object({
    guestId: z.string()
        .refine(isValidGuestSignInId, "That isn't a valid guest ID.")
        .transform(normalizeGuestSignInId),
});
//# sourceMappingURL=auth.schemas.js.map